export const clearStorage = () => {
  localStorage.removeItem('me');
  localStorage.removeItem('vmode');
  localStorage.removeItem('cid');
  localStorage.removeItem('cname');
  localStorage.removeItem('ctype');
  localStorage.setItem('urlPrefix', '');
};
